// extracted by mini-css-extract-plugin
export default {"feedbackContainer":"HM-z","upvoteIcon":"IM-z","downvoteIcon":"JM-z","feedbackIcon":"KM-z"};